var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGateway = function SvgGateway(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1161.6 583.2 961.2 428.4c-14.398-10.801-33.602-1.2-33.602 16.801l.004 82.801h-128.4v-201.6c0-94.801-76.801-172.8-172.8-172.8h-240c-94.801 0-172.8 76.801-172.8 172.8l.004 201.6h-162c-12 0-21.602 9.602-21.602 21.602v102c0 12 9.601 21.602 21.602 21.602h164.4v201.6c0 94.801 76.8 172.8 172.8 172.8h240c94.8 0 172.8-76.801 172.8-172.8v-202.8h127.2v82.801c0 18 20.398 27.602 33.602 16.801l200.4-154.8c9.598-8.402 9.598-25.199-1.2-33.602zM700.8 873.6c0 40.801-32.398 73.199-73.199 73.199h-240c-40.801 0-73.199-32.398-73.199-73.199l-.004-201.6h290.4l.004-144h-290.4V326.4c0-40.801 32.398-73.199 73.199-73.199h240c40.801 0 73.199 32.398 73.199 73.199z"
  })));
};

export default SvgGateway;